<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/jxky/home">教学科研</router-link> >
      <router-link to="/jxky/yanjiusheng">研究生教育</router-link> >
      {{ infos.name }}
    </div>
    <div class="container-width x-article">
      <div class="doctor_box">
        <img :src="infos.img" class="doctor_img" />
        <img src="@/assets/image/doctor_clip.png" alt="" class="doctor_clip" />
        <div class="doctor_msg" v-if="DWIDTH == true">
          <h5>{{ infos.name }}</h5>
          <p>出生年月：{{ infos.birthDate }}</p>
          <p>导师类型：{{ infos.type }}</p>
          <p>所属学科：{{ subname }}</p>
          <p>研究方向：{{ infos.researchDirection }}</p>
          <p>电子邮箱：{{ infos.email }}</p>
        </div>
      </div>
      <div class="doctor_msg" v-if="DWIDTH == false">
        <h5>{{ infos.name }}</h5>
        <p>出生年月：{{ infos.birthDate }}</p>
        <p>导师类型：{{ infos.type }}</p>
        <p>所属学科：{{ subname }}</p>
        <p>研究方向：{{ infos.researchDirection }}</p>
        <p>电子邮箱：{{ infos.email }}</p>
      </div>
      <div class="list">
        <div class="j-item"><span>导师介绍</span></div>
        <div v-html="infos.description" class="j-description"></div>
      </div>
      <div class="list">
        <div class="j-item"><span>学术任职</span></div>
        <div v-html="infos.academicActivities" class="j-description"></div>
      </div>
      <div class="list">
        <div class="j-item"><span>相关医生</span></div>
        <div class="d-list">
          <!-- v-for="(item, index) in boshiData"
                :key="index"
                @click="goDaoshi(item)"
                v-if="item.name != infos.name && item.type == infos.type"
              >
                {{ item.name }} {{ subname }} -->
          <div
            class="d-item"
            v-for="(item, index) in boshiData"
            :key="index"
            v-if="item.name != infos.name && item.type == infos.type"
          >
            <div class="d-avatar" @click="goDaoshi(item)">
              <img :src="item.url" />
              <div class="d-description">
                <p class="multi-ellipsis">{{ subname }}</p>
              </div>
            </div>
            <div class="d-name" @click="goDaoshi(item.id)">
              <span class="doctor_zhicheng">「 {{ item.type }} 」</span><br />
              <span class="doctor_name">{{ item.name }}</span>
            </div>
          </div>
          <div
            class="d-item"
            v-for="(item, index) in shuoshiData"
            :key="index"
            v-if="item.name != infos.name && item.type == infos.type"
          >
            <div class="d-avatar" @click="goDaoshi(item)">
              <img :src="item.url" />
              <div class="d-description">
                <p class="multi-ellipsis">{{ subname }}</p>
              </div>
            </div>
            <div class="d-name" @click="godoctor(item.id)">
              {{ item.name }} <span>「 {{ item.type }} 」</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import service from "../../service/jxky";
import config from "../../config/dev";
import BANNER from "../../components/banner/jxky";
import { jxkyNavDic } from "../../const/navigationData";
export default {
  name: "YANJIUSHENGDAOSHI",
  data() {
    return {
      navigationData: jxkyNavDic,
      currentPath: "/jxky/yanjiusheng",
      id: 0,
      subname: "",
      infos: {},
      boshiData: [],
      shuoshiData: [],
      sjkdData: [],
      mtksjData: [],
      ylzhData: [],
      maleImg: require("../../assets/image/male.png"),
      DWIDTH: true,
    };
  },
  components: { BANNER },
  computed: {},
  created() {
    this.id = this.$route.query.id || 0;
    this.subname = this.$route.query.xueke || "";
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      let parmes = {
        id: this.id,
      };
      service.getwzGraduateSubTea(parmes, (res) => {
        res.birthDate = res.birthDate.split("-")[0] + "年";
        res.type = res.type == 1 ? "博士导师" : "硕士导师";
        res.img =
          config.url + "/file/downloadFile/" + res.img + "?isDownload=true";
        this.infos = { ...res };

        this.getTeacher(res.subjectId);
      });
      //相关推荐
      let parmes2 = {
        teacherId: this.id,
        table: "teacher_suggest",
      };
      let sjkdData = [];
      let mtksjData = [];
      let ylzhData = [];
      service.getwzGraduateSuggested(parmes2, (res) => {
        if (res.content.length) {
          res.content.map((item) => {
            item.title = item.title.substr(0, 16) + "...";
            if (item.type == "医疗纵横") {
              ylzhData.push(item);
            }
            if (item.type == "媒体看盛京") {
              mtksjData.push(item);
            }
            if (item.type == "盛京看点") {
              sjkdData.push(item);
            }
          });
        }
        this.sjkdData = sjkdData || [];
        this.mtksjData = mtksjData || [];
        this.ylzhData = ylzhData || [];
      });
    },
    getTeacher(subjectId) {
      let parmes = {
        subjectId: subjectId,
      };
      service.getwzGraduateList(parmes, (res) => {
        let boshiData = [];
        let shuoshiData = [];
        if (res.content.length) {
          res.content.map((item) => {
            item.url = item.img
              ? config.url +
                "/file/downloadFile/" +
                item.img +
                "?isDownload=true"
              : this.maleImg;
            if (item.type == "博士导师") {
              boshiData.push(item);
            } else {
              shuoshiData.push(item);
            }
            this.boshiData = boshiData;
            this.shuoshiData = shuoshiData;
          });
        }
      });
    },

    goDaoshi(item) {
      let articleId = item.id || 0;
      let name = this.subname || "";
      const { href } = this.$router.resolve({
        path: `/jxky/yanjiusheng/daoshi`,
        query: {
          id: `${articleId}`,
          xueke: `${name}`,
        },
      });
      window.open(href, "_blank");
    },
    gokdArticle(e) {
      if (e.url.length) {
        window.open(e.url, "_blank");
      } else {
        let articleId = e.id;
        const { href } = this.$router.resolve({
          path: `/sjkd/article/${articleId}`,
        });
        window.open(href, "_blank");
      }
    },

    goylzhArticle(e) {
      if (e.url.length) {
        window.open(e.url, "_blank");
      } else {
        let articleId = e.id;
        const { href } = this.$router.resolve({
          path: `/sjkd/ylzh/article/${articleId}`,
        });
        window.open(href, "_blank");
      }
    },
    gomtksjArticle(e) {
      if (e.url.length) {
        window.open(e.url, "_blank");
      } else {
        let articleId = e.id;
        const { href } = this.$router.resolve({
          path: `/lxwm/mtksj/article/${articleId}`,
        });
        window.open(href, "_blank");
      }
    },
  },
  mounted() {
    // 设备宽度小于720px 时
    if (window.screen.width < 720) {
      this.DWIDTH = false;
    } else {
      this.DWIDTH = true;
    }
  },
  watch: {},
};
</script>


<style scoped lang="scss">
.container-width {
  overflow-x: hidden;
}
.doctor_box {
  width: 100%;
  position: relative;
  padding-left: 328px;
  padding-top: 1px;
  margin-top: 50px;
  margin-bottom: 50px;
  height: 430px;
}
.list {
  .j-item {
    border-bottom: 1px solid #00479d;
    span {
      display: inline-block;
      padding: 0 60px;
      background: #00479d;
      color: #fff;
      height: 40px;
      line-height: 40px;
      text-align: center;
    }
  }
  .j-description {
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 1.1rem;
    line-height: 40px;
    color: #333;
  }
}
.doctor_clip {
  position: absolute;
  left: 0;
  top: 0;
}
.doctor_img {
  position: absolute;
  left: 55px;
  top: 71px;
  width: 214px;
  height: 270px;
}

.doctor_msg {
  position: relative;
  z-index: 1;
  background-color: #fff;
  box-shadow: 5px 5px 24px -6px rgba(51, 51, 51, 0.1);
  margin-top: 33px;
  padding: 38px 70px 38px 38px;
  min-height: 361px;
  box-sizing: border-box;
  width: calc(100% - 330px);
}
.doctor_msg h5 {
  font-size: 1.4rem;
  color: #333;
  line-height: 30px;
}
.doctor_msg h5 span {
  font-size: 16px;
  color: #333;
}
.doctor_msg img {
  margin-top: 26px;
  display: block;
}
.doctor_msg p {
  font-size: 14px;
  line-height: 28px;
  color: #333;
  margin-top: 15px;
}
.d-list {
  width: 100%;
  margin-bottom: 20px;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  row-gap: 30px;
  column-gap: 30px;
  margin-top: 50px;
  .d-item {
    width: 100%;
    margin-right: 15px;
    //height: 382px;/* 显示6个的时候 */
    overflow: hidden;
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
    cursor: pointer;
    .d-avatar {
      position: relative;
      text-align: center;
      // height: 342px; /* 显示6个的时候 */
      // width: 205px; /* 显示6个的时候 */
      img {
        -webkit-transform: scale(1);
        transform: scale(1);
        -webkit-transition: all 0.4s ease;
        transition: all 0.4s ease;
        max-width: 100%; /* 显示6个的时候 */
        height: 180px; /* 显示6个的时候 */
        overflow: hidden;
      }
      .d-description {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: url(../../assets/image/mask40.png);
        text-align: center;
        color: #fff;
        line-height: 24px;
        font-size: 14px;
        overflow: hidden;
        padding: 10px;
        box-sizing: border-box;
        height: 40px;
      }
    }
    .d-name {
      height: 60px;
      flex: 1;
      text-align: center;

      .doctor_zhicheng {
        font-size: 12px;
        color: #333;
      }
      .doctor_name {
        font-size: 1.2rem;
        // color: #333;
        font-weight: 600;
      }
    }
  }
}
@media only screen and (max-width: 728px) {
  .d-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    row-gap: 10px;
    column-gap: 10px;
    margin-top: 20px;
  }
  .doctor_box {
    margin-left: calc((50% - 165px) / 2);
  }
  .list {
    .j-item {
      span {
        padding: 0 30px;
      }
    }
    .j-description {
      line-height: 25px;
    }
  }

  .doctor_clip {
    position: absolute;
  }
  .doctor_msg {
    width: 100%;
    padding: 15px;
  }
}
@media only screen and (min-width: 420px) and (max-width: 720px) {
  .d-list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    row-gap: 15px;
    column-gap: 15px;
    margin-top: 30px;
  }
}
@media only screen and (min-width: 720px) and (max-width: 1280px) {
  .d-list {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    row-gap: 20px;
    column-gap: 20px;
    margin-top: 50px;
  }
}
</style>
